@if (state.isReady()) {
  <div>
    <!-- preview and modal full file -->
    @if (gotFullFile && !limitRows && rowCount > 0) {
      <!-- prettier-ignore -->
      <span style="font-size: smaller">
        Showing all {{ rowCount }} rows@if (limitColumns) {<span> and the first {{ columnLimit }} columns</span>}.
      </span>
    }
    @if (gotFullFile && !limitRows && rowCount === 0) {
      <span style="font-size: smaller">No data rows.</span>
    }

    <!-- preview, full file, but preview limiting visible rows -->
    @if (!modalMode && gotFullFile && limitRows) {
      <!-- prettier-ignore -->
      <span style="font-size: smaller">
        Showing the first {{ rowCount }} of {{ rowCountBeforeLimit }} rows@if (limitColumns) {<span> and the first {{ columnLimit }} columns</span>}.
      </span>
    }

    <!-- preview, line count maybe available in full screen-->
    @if (!modalMode && !gotFullFile) {
      <!-- prettier-ignore -->
      <span style="font-size: smaller">
        Showing the first {{ rowCount }} rows@if (limitColumns) {<span> and the first {{ columnLimit }} columns</span>}.
      </span>
    }

    <!-- modal, total count not available -->
    @if (modalMode && !gotFullFile) {
      <!-- prettier-ignore -->
      <span style="font-size: smaller">
        Showing the first {{ rowCount }} rows@if (limitColumns) {<span> and the first {{ columnLimit }} columns</span>}. File is too big for total row count.
      </span>
    }

    <!-- full screen text and link for preview-->
    @if (!modalMode && (!gotFullFile || limitRows)) {
      <span style="font-size: smaller">
        View in
        <ch-link-button class="no-underline-link-button" (click)="showAll()">full screen</ch-link-button>
        {{ goToFullScreenText }}.
      </span>
    }

    @if (!modalMode) {
      <ch-link-button (click)="showAll()" class="no-underline-link-button float-end">
        <i class="fa-solid fa-expand"></i>
        Full Screen
      </ch-link-button>
    }
  </div>
} @else {
  <ch-status [state]="state"></ch-status>
}

<!-- tableContainer must always be around or new Handsontable fails, so no ngIf for it -->

<!-- wrapper div needed for horizontal-scroll, but messes things up when in modalMode -->
@if (!modalMode) {
  <div class="horizontal-scroll" #horizontalScroll>
    <div id="{{ tableContainerId }}" class="spreadsheet-table-container"></div>
  </div>
}

@if (modalMode) {
  <div id="{{ tableContainerId }}" class="spreadsheet-table-container"></div>
}
